import AuthManager from '@services/AuthManager';
// import { onRedirectionCLick } from '../services/utils';
// import careHost from '../utils/careHost'

const createRedirectionForm = (authToken, merchantId, redirectionUrl, redirectToUrl) => {
  const authTokenInput = document.createElement('INPUT');
  const merchantIdInput = document.createElement('INPUT');
  const redirectionForm = document.createElement('FORM');
  redirectionForm.setAttribute('id', 'redirection-form');
  redirectionForm.setAttribute('action', redirectionUrl);
  redirectionForm.setAttribute('method', 'POST');
  redirectionForm.setAttribute('style', 'display:none');
  document.body.appendChild(redirectionForm);
  authTokenInput.setAttribute('type', 'TEXT');
  authTokenInput.setAttribute('name', 'authToken');
  authTokenInput.setAttribute('value', authToken);
  merchantIdInput.setAttribute('type', 'TEXT');
  merchantIdInput.setAttribute('name', 'merchantId');
  merchantIdInput.setAttribute('value', merchantId);
  redirectionForm.appendChild(authTokenInput);
  redirectionForm.appendChild(merchantIdInput);
  if (redirectToUrl) {
    const redirectToInput = document.createElement('INPUT');
    redirectToInput.setAttribute('type', 'TEXT');
    redirectToInput.setAttribute('name', 'redirectTo');
    redirectToInput.setAttribute('value', redirectToUrl);
    redirectionForm.appendChild(redirectToInput);
  }
  redirectionForm.submit();
};

export const onRedirectionClick = (redirectToUrl) => {
  const user = AuthManager.getUser();

  if (user && user.dashboard_preference === 'one_dashboard') {
    let oneDashboardUrl = process.env.ONE_DASHBOARD_HOST;
    oneDashboardUrl = new URL(oneDashboardUrl);
    window.location.href = oneDashboardUrl;
  } else {
    const bizRedirectionUrl = process.env.BIZ_LOGIN_URL;
    const fullToken = AuthManager.getFullToken();
    /* redirect the merchant to logout path if any one of three full_token, user.mid , redirection_url is not present */
    if (!fullToken || !user || !user.mid || !bizRedirectionUrl) {
      window.location.href = '/account/service_logout';
    }
    createRedirectionForm(fullToken, user.mid, bizRedirectionUrl, redirectToUrl);
  }
};

export const goToDashboard = () => {
  const user = AuthManager.getUser();
  if (user && user.product === 'PayUmoney') {
    window.open(`${process.env.MONEY_HOST}/merchant-dashboard/#/transactions`, '_self');
  } else if (user && user.product === 'PayUbiz') {
    onRedirectionClick();
  }
}

export const getMenuList = () => {
  const user = AuthManager.getUser();
  const signOut = {
    label: 'Sign Out',
    variant: 'underlined',
    onClick: () => window.open('/account/service_logout', '_self'),
  };

  const backToDashBoard = {
    label: 'Back To Dashboard',
    variant: 'outlined',
    startIcon: { type: 'summary', color: 'primary' },
  };

  if (user && user.product === 'PayUmoney') {
    backToDashBoard.onClick = () =>
      window.open(`${process.env.MONEY_HOST}/merchant-dashboard/#/transactions`, '_self');
  } else if (user && user.product === 'PayUbiz') {
    backToDashBoard.onClick = onRedirectionClick;
  }

  return [signOut, backToDashBoard];
};
